function headerDigitalks() {
  function isScrollOnTheTop() {
    const pageY = window.pageYOffset;

    if (pageY > 100) {
      return false;
    }

    return true;
  }

  function isFrontPage(header) {
    if (header.dataset.isFrontPage === '1') {
      return true;
    }

    return false;
  }

  function toggleHeaderTransparency() {
    const header = document.querySelector('.header-digitalks');

    if (!header) {
      return;
    }

    if (isScrollOnTheTop() && isFrontPage(header)) {
      header.classList.add('header-digitalks--transparent');
      return;
    }

    header.classList.remove('header-digitalks--transparent');
  }

  function listenPageScrollForToggle() {
    document.addEventListener('scroll', () => toggleHeaderTransparency());
  }

  return {
    listenPageScrollForToggle
  }
}
const header = headerDigitalks();

window.addEventListener('load', () => header.listenPageScrollForToggle());
